const errorManage = async (err) => {
  if (err.response?.status === 401 || err.response?.status === 403) {
    localStorage.clear();
    // window.location.reload();
    window.location.href = window.location.pathname + "?p=login";
  }
  
  return;
};

module.exports = { errorManage };
